// app 1.5.67 (Alexander, 5 Nov 13:50) — the one M® Toolbox distribution: the page served beside the app, fetched once and
// checked to be the Toolbox, then packaged two ways — inside the Spare Key's recovery .zip (with the Blank Key), and alone as
// M-toolbox.zip for Settings → M® Toolbox → Get (a .zip because some email programmes block .html attachments). Both read
// the same bytes from here, so a recovery package and a standalone download always carry the same Toolbox.
// Kept apart from keyfile.ts so the M Toolbox's own bundle (and its fingerprint) is unchanged.
import { zipFiles, zipOne } from "./zip";

/** The M Toolbox, served beside the app, the name it has inside a .zip, and the standalone .zip's name. */
export const TOOLBOX_PATH = "/M-toolbox.html";
export const TOOLBOX_NAME = "M-toolbox.html";
export const TOOLBOX_ZIP = "M-toolbox.zip";

async function fetchToolbox(): Promise<Uint8Array> {
  const r = await fetch(TOOLBOX_PATH, { cache: "no-cache" });
  if (!r.ok) throw new Error(`toolbox ${r.status}`);
  const bytes = new Uint8Array(await r.arrayBuffer());
  // The SPA fallback answers any path with the app's own page: make sure this is the Toolbox.
  if (!new TextDecoder().decode(bytes.subarray(0, 4000)).includes("M TOOLBOX")) throw new Error("toolbox: not the M Toolbox page");
  return bytes;
}

let page: Promise<Uint8Array> | null = null;
/** The Toolbox page's bytes, fetched once per page load; a failed fetch is tried again at the next call. */
export function toolboxPage(source: () => Promise<Uint8Array> = fetchToolbox): Promise<Uint8Array> {
  if (!page) {
    const p = source();
    page = p;
    p.catch(() => { if (page === p) page = null; });
  }
  return page;
}

/** Settings → M® Toolbox → Get: the page alone, as M-toolbox.zip. */
export function toolboxZip(source?: () => Promise<Uint8Array>): Promise<Uint8Array> {
  return toolboxPage(source).then((html) => zipOne(TOOLBOX_NAME, html));
}

/** The Spare Key's recovery package: the Blank Key and the Toolbox in one stored .zip. */
export function recoveryZip(blankKeyName: string, blankKeyText: string, source?: () => Promise<Uint8Array>): Promise<Uint8Array> {
  return toolboxPage(source).then((html) =>
    zipFiles([{ name: blankKeyName, content: new TextEncoder().encode(blankKeyText) }, { name: TOOLBOX_NAME, content: html }]));
}
